
import axios from 'axios';

// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';

import { NotificationManager } from 'react-notifications';
import {
   ALL_ROLES,
   ADD_ROLE,
   ROLE_ACTION,
   EDIT_ROLE,
   STATUS_ROLE,
   DELETE_ROLE
} from 'Actions/types';

/**
 * Redux Action To Sigin User With Firebase
 */
export const allRoles = () =>{    
    
    return (dispatch) => { 
        dispatch({ type: ROLE_ACTION });
        return axios.get(AppConfig.apiurl+'/api/getroles', { headers: AuthHeader.header })         
        .then(response => {             
            const allroles=response.data.data;
            dispatch({ type: ALL_ROLES, payload: allroles });
        });
   }
}

export const addRole = (name,stdrole) => async (dispatch) => {
    
    var payload={
        "name":name,
        "stdrole":stdrole
     }
     dispatch({ type: ROLE_ACTION });
    axios.post(AppConfig.apiurl+'/api/addrole', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
               allRoles()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: ADD_ROLE });
            }else{
               NotificationManager.error(resdata.message); 
            }
         }else{
            NotificationManager.error('Role not added');
         }            
         
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
}

export const editRole = (name,stdrole,id) => async (dispatch) => {
    
    var payload={
        "id":id,
        "name":name,
        "stdrole":stdrole
     }
     dispatch({ type: ROLE_ACTION });
    axios.post(AppConfig.apiurl+'/api/editrole', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
               allRoles()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: EDIT_ROLE });
            }else{
               NotificationManager.error(resdata.message); 
            }
         }            
         
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
}

export const statusRole = (id,status) => async (dispatch) => {
    
    var payload={
        "id":id,
        "status":status
     }
     dispatch({ type: ROLE_ACTION });
    axios.post(AppConfig.apiurl+'/api/statusrole', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
               allRoles()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: STATUS_ROLE });
            }else{
               NotificationManager.error(resdata.message); 
            }
         }            
         
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
}

export const deleteRole = (id) => async (dispatch) => {
    
    var payload={
        "id":id
     }
     dispatch({ type: ROLE_ACTION });
    axios.post(AppConfig.apiurl+'/api/deleterole', payload, { headers: AuthHeader.header })
     .then( response => {       
         if(response.status==200){ 
            var resdata=response.data;
            if(resdata.status===1){
               allRoles()(dispatch);
               NotificationManager.success(resdata.message);               
               dispatch({ type: DELETE_ROLE });
            }else{
               NotificationManager.error(resdata.message); 
            }
         }            
         
     })
     .catch( error => { 
       NotificationManager.error(error);
     });
}


